module.exports = __webpack_public_path__ + "static/media/menu-black.bcb85624.svg";